export const accountGenericError = 'Unable to create account holder';
export const accountExistError = 'Account holder already exists';
export const patientExistError = 'Patient already exists';
export const patientLicenseKeyMissingError = 'Account holder found with blank license key';
